import React from 'react';
import PropTypes from 'prop-types';

const ExchangesPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M14.25 12.667l.003 2.68c0 .367-.308.653-.688.653a.684.684 0 0 1-.547-.25L6.14 11.401a.65.65 0 0 1 0-.806l6.878-4.348c.23-.293.661-.324.963-.1a.609.609 0 0 1 .272.503l-.002 2.184h12.062c.379 0 .687.299.687.666V12a.678.678 0 0 1-.687.667H14.25zm5.5 7.666l-.003-2.68c0-.367.308-.653.688-.653.215 0 .417.085.547.25l6.878 4.349a.65.65 0 0 1 0 .806l-6.878 4.348c-.23.293-.661.324-.963.1a.609.609 0 0 1-.272-.503l.002-2.184H7.687A.677.677 0 0 1 7 23.5V21c0-.368.308-.667.687-.667H19.75z"
    />
  );
};

ExchangesPath.propTypes = {
  fill: PropTypes.string,
};

export default ExchangesPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/exchanges.jsx